// Lib
import React from 'react';
import { useSelector } from 'react-redux';

// Utils
import { getPlatformTypeSelector } from '../../platform/platformSelector';
import { PlatformType } from '../../../common/platform/platformTypes';

// Styles
import './MobileNavigationBar.scss';

const MobileNavigationBar: React.FC = () => {
    const isAndroid = useSelector(getPlatformTypeSelector) == PlatformType.android;
    if (!isAndroid) return null;
    return <div className="MobileNavigationBar" />;
};

export default MobileNavigationBar;
